import React from 'react';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {getCustomerDetails} from '../actions';
import {Layout, PageHeader, Spinner} from '../components';
import CardModal from '../components/Modals/CardModal';

const AddCard = ({edit}) => {
  const navigate = useNavigate();
  const {id} = useParams();
  const dispatch = useDispatch();
  const {customerById, customersLoading} = useSelector(s => s.customers);
  const {cardById} = useSelector(s => s.cards);

  const onBack = () => navigate(-1);

  useEffect(() => {
    if (edit) {
      dispatch(getCustomerDetails(cardById.customerId));
    } else {
      dispatch(getCustomerDetails(id));
    }
  }, []);

  if (edit) {
    return (
      <>
        {customersLoading ? (
          <Spinner />
        ) : (
          customerById && <CardModal customer={customerById} edit={edit} />
        )}
      </>
    );
  }

  return (
    <Layout>
      <PageHeader onBack={onBack} />
      {customersLoading ? (
        <Spinner />
      ) : (
        customerById && <CardModal customer={customerById} />
      )}
    </Layout>
  );
};

export default AddCard;
